<template>
  <b-form-group
    label="Detalhes do Aluguel"
    label-for="rent-details"
    class="rent-details"
  >
    <div v-if="compact" class="rent-details-compact mb-2">
      <div class="rent-details-grid">
        <div>
          <small>Cliente</small>
          <strong>
            {{
              (toy.rent && toy.rent.customer && toy.rent.customer.name) ||
              'Cliente não encontrado'
            }}
          </strong>
        </div>
        <div>
          <small>Brinquedo</small>
          <strong>{{ toy.name }}</strong>
        </div>
        <div>
          <small>Periodo</small>
          <strong>
            {{ toy.rent.period.time }} min -
            {{ toy.rent.period.price | formatCurrency }}
          </strong>
        </div>
        <div v-if="toy.rent.pausedTime > 0">
          <small>Pausa</small>
          <strong>{{ toy.rent.pausedTime }} minuto(s)</strong>
        </div>
        <div v-if="extraTimeStrings" class="rent-details-extra">
          <small>Tempo Extra</small>
          <strong>{{ extraTimeStrings }}</strong>
        </div>
        <div v-if="!hideTotal">
          <small>Valor Total</small>
          <strong>R$ {{ toy.rent.rentAmount }}</strong>
        </div>
      </div>
    </div>
    <template v-else>
      <b-card class="mb-2">
        <b-row>
          <b-col>
            <b-form-group label="Cliente">
              <b-input
                class="border-0"
                readonly
                :value="
                  (toy.rent && toy.rent.customer && toy.rent.customer.name) ||
                  'Cliente não encontrado'
                "
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Brinquedo">
              <b-input class="border-0" readonly :value="toy.name" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group label="Período">
              <b-input
                class="border-0"
                readonly
                :value="`${toy.rent.period.time} min - ${formatCurrency(
                  toy.rent.period.price
                )}`"
              />
            </b-form-group>
          </b-col>

          <b-col v-if="toy.rent.pausedTime > 0">
            <b-form-group label="Pausa">
              <b-input
                class="border-0"
                readonly
                :value="`${toy.rent.pausedTime} minuto(s)`"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group label="Tempo Extra">
          <b-textarea
            class="border-0"
            readonly
            :value="extraTimeStrings"
            no-resize
          />
        </b-form-group>

        <b-form-group v-if="!hideTotal" label="Valor Total">
          <b-input
            class="border-0"
            readonly
            :value="`R$ ${toy.rent.rentAmount}`"
          />
        </b-form-group>
      </b-card>
    </template>
  </b-form-group>
</template>

<script>
import { formatCurrency } from '@/helpers/numbers'

export default {
  name: 'ToyRentDetails',
  props: {
    toy: {
      type: Object,
      required: true
    },
    hideTotal: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    extraTimeStrings() {
      return this.toy.rent.extraTime
        .filter((entry) => entry.type === null)
        .map(
          (entry) =>
            `+ ${entry.minutes} minuto(s)${
              entry.reason ? ' - ' + entry.reason : ''
            }`
        )
        .join('\n')
    }
  },
  watch: {
    toy: {
      handler({ rent }) {
        // Emite valores pré-calculados para o componente pai
        this.$emit('update-rent-amount', rent.rentAmount)
        this.$emit('update-products-amount', rent.productsAmount || 0)
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    formatCurrency(value) {
      return formatCurrency(value)
    }
  }
}
</script>

<style lang="scss">
.rent-details-compact {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 0.75rem;
}

.rent-details-grid {
  display: grid;
  gap: 0.55rem 0.85rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  small {
    color: #6c757d;
    display: block;
    font-size: 0.75rem;
    line-height: 1.1;
    margin-bottom: 0.1rem;
  }

  strong {
    display: block;
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 1.25;
    min-width: 0;
    overflow-wrap: anywhere;
  }
}

.rent-details-extra {
  grid-column: 1 / -1;
}

@media (max-width: 575.98px) {
  .rent-details-grid {
    grid-template-columns: 1fr;
  }
}
</style>
